import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import BasicOnInput from 'Components/common/BasicOnInput';
import Anchor from 'Components/common/Anchor';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import { T } from 'Actions/translate';

const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: theme.spacing.unit / 3,
      boxShadow: `0px 1px 3px 0px rgb(0 0 0 / 7%), 0px 2px 2px 0px rgb(0 0 0 / 0%)`,
    },
    chip: {
      margin: theme.spacing.unit / 3,
      padding: theme.spacing.unit / 9,
    },
  });

class ChipTag extends Component {

    constructor(props){
        super(props)
        this.state = {
            chipData: [],
            tagValue:''
        }
    }

    //delete
    handleDelete = data => () => {
        this.setState(state => {
          const chipData = [...state.chipData];
          if(chipData.indexOf(data)!==-1){
            const chipToDelete = chipData.indexOf(data);
            chipData.splice(chipToDelete, 1);
            this.props.handleBtn(chipData,'delete')
            return { chipData };
          }
          else{
            this.props.handleBtn(data,'delete')
            return data;
          }
        });
      };

      //点击 button
      clickBtn = ()=>{
        const { tagValue } = this.state
        if(tagValue===''){
            return
        }else{
            this.setState(state => {
                const chipData = [...state.chipData];
                chipData.push(tagValue.trim());
                this.props.handleBtn(chipData,'add')
                this.setState({
                    tagValue:''
                })
                return { chipData };
            });
        }
      }

      handleValid = (name,value,isNotEmail)=>{
        if(isNotEmail){
            this.props.inputValid(value)
            this.setState({
                tagValue:value
            })
        }else{
            return
        }
      }


    render() {
        const {title,placeholder, defalutValue,required,checkEmail,value,btnValue,classes,tagData } = this.props;
        const { chipData } = this.state;
        // 将外部传入的tag合并
        let data=[]
        if(tagData && tagData.length>0){
            data = [...tagData,...chipData]
        }else{
            data = chipData
        }

        return (
            <div className="basic-chip-container">
                <div className='basic-chip-container-input'>
                    <Grid item xs={10}>
                        <BasicOnInput
                                title={title}
                                placeholder={placeholder}
                                defalutValue={defalutValue}
                                inputValid={this.handleValid}
                                type="text"
                                required={required}
                                checkEmail={checkEmail}
                                value={value}
                        />
                    </Grid>
                    <Anchor className="basic-tag-chip" onClickOfSingleTap={this.clickBtn}>
                        <span className="basic-tag-chip-btn">{T(btnValue)}</span>
                    </Anchor>
                </div>
                {
                    data.length>0 ?
                    <div>
                        <Paper className={classes.root}>
                            {data.map(item => {
                            let icon = null;

                            return (
                                <Chip
                                    key={item}
                                    icon={icon}
                                    label={item}
                                    onDelete={this.handleDelete(item)}
                                    className={classes.chip}
                                    variant="outlined"
                                />
                                );
                            })}
                        </Paper>
                    </div> :null
                }  
            </div>
        )
    }
}

ChipTag.propTypes = {
    title: PropTypes.string.isRequired,
    value:PropTypes.string,
    required:PropTypes.bool,
    inputValid: PropTypes.func,
    checkEmail:PropTypes.bool,
    classes: PropTypes.object.isRequired,
    tagData:PropTypes.array,
};

export default withStyles(styles)(ChipTag);
